import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-scroll"
//
// Keeps a scrollable container pinned to its bottom edge as new content
// is appended (chat transcripts, log streams). If the user scrolls up
// to read history, we pause auto-scroll until they return to the bottom.
export default class extends Controller {
  connect() {
    this.userScrolledUp = false
    this.boundScroll = this.handleScroll.bind(this)
    this.element.addEventListener("scroll", this.boundScroll, { passive: true })

    // Initial pin
    this.scrollToBottom()

    // Re-pin whenever children change (Turbo Stream appends, replaces).
    this.observer = new MutationObserver(() => {
      if (!this.userScrolledUp) this.scrollToBottom()
    })
    this.observer.observe(this.element, { childList: true, subtree: true })

    // Always pin after a form submit in this controller's element (the
    // user just sent a message — they want to see what they typed land,
    // even if they had scrolled up earlier).
    this.boundSubmit = this.handleSubmit.bind(this)
    this.element.addEventListener("turbo:submit-end", this.boundSubmit)
  }

  disconnect() {
    this.element.removeEventListener("scroll", this.boundScroll)
    this.element.removeEventListener("turbo:submit-end", this.boundSubmit)
    this.observer?.disconnect()
  }

  handleScroll() {
    this.userScrolledUp = !this.atBottom()
  }

  handleSubmit() {
    this.userScrolledUp = false
    // Wait a frame so the optimistic-rendered new message is in the DOM.
    requestAnimationFrame(() => this.scrollToBottom())
  }

  atBottom() {
    const threshold = 60
    return this.element.scrollHeight - this.element.scrollTop - this.element.clientHeight < threshold
  }

  scrollToBottom() {
    this.element.scrollTop = this.element.scrollHeight
  }
}
